export default function RIFLECriteriaComponent() {
  return <></>;
}
